// 记录关键节点的时间
const perfRecord = []
const start = Number(localStorage.getItem('t_html_loading'))
const tiktok = (action, id, needPrint) => {
  const time = new Date().getTime()
  const cost = time - start
  const key = `${action}_${id}`
  perfRecord.push({ key, time, cost })
  if (needPrint) {
    printPerfInfo()
  }
}

function printPerfInfo() {
  // 延迟3秒，以打印更多、更全面的性能数据
  setTimeout(() => {
    let msg = '=======【页面加载性能报告123】=======\n'
    perfRecord.forEach((item) => {
      const { key, cost } = item
      msg += `${cost}ms...${key}\n`
    })
    msg += '==============================='
    console.log(msg)
  }, 2000)
}
export default {
  install(Vue) {
    Vue.mixin({
      created: function () {
        if (this.getComponentName()) {
          const name = this.getComponentName()
          tiktok('created', name, name == 'Home')
        }
      },
      mounted: function () {
        if (this.getComponentName()) {
          const name = this.getComponentName()
          tiktok('mounted', name)
        }
      },
      methods: {
        getComponentName() {
          if (
            this.$options.name &&
            this.$options.name.indexOf('z-') == -1 && // zzui组件
            this.$options.name !== 'transition' //vue transition 组件
          ) {
            return this.$options.name
          }
          return false
        }
      }
    })
  }
}
